module.exports = __webpack_public_path__ + "static/media/medal.c5d7ac14.svg";